module.exports = __webpack_public_path__ + "static/default-whatsapp-5142d460d9a1ed7e1efa627f267f31a9.svg";